import { createFileRoute } from "@tanstack/react-router";
import { CredentialSettings } from "@/components/settings/credential-settings";

export const Route = createFileRoute("/_workspace/settings/credentials")({
  component: CredentialSettings,
});
